import './style.scss';

const ComingSoon = () => {
  return (
    <div className='coming-soon-wrapper'>
      <div className='react-glitch-wrapper'>
        <div className='rect-glitch-text' data-text={'COMING SOON...'}>
          COMING SOON...
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
